import React, { useEffect, useRef, useState } from "react"
import { Image, Input, List, Loader } from "semantic-ui-react"
import useSound from 'use-sound';
import { Sounds } from "../../assets/assets"
import './style.css'
import { onError } from "../shared/messages";
import { endpointAPI } from "../../api/http";
import * as signalR from "@microsoft/signalr";
import { useCurrentHotel } from "../../hooks/useCurrentHotel";
import ReactMarkdown from "react-markdown";
import PropTypes from 'prop-types';
import moment from "moment";

export const Optimon = ({onChange, setFunctions, fresh, instructions, startup, events}) => {
    const [messages, setMessages] = useState([])
    const [message, setMessage] = useState("")
    const [threadId, setThreadId] = useState()
    const [connection, setConnection] = useState();
    const [listening, setListening] = useState(false)
    const [answering, setAnswering] = useState(false)
    const scrollTo = useRef()
    const inputRef = useRef(null);
    const [direction, setDirection] = useState("ltr");

    const endpointHub = window?.optima?.$optimaUrls?.WebAPIPath?.replace("/api", "/optimonHub") || "https://localhost:44363/optimonHub"

    var currentHotel = useCurrentHotel();
    
    useEffect(() => {
        setFunctions?.({createThread, addMessage, reloadThread})
    }, [connection, threadId, messages])


    useEffect(() => {
        onChange?.({threadId, messages})
    }, [messages, threadId])

    useEffect(() => {
        const user = window.$user || window.user || window.optima?.user || window.SelfieSettings?.settings?.user
        const newConnection = new signalR.HubConnectionBuilder()
            .withUrl(endpointHub, {
                accessTokenFactory: () => user?.UserToken
            })
            .withAutomaticReconnect()
            .build();

        setConnection(newConnection);
    }, []);

    useEffect(() => {
        if (connection) {
            (async () => {
                try {
                    await connection.start()
                    console.log("Connected to SignalR");
                    let threadId = localStorage.getItem("OptimonThreadId")
                    if (fresh || !threadId) {
                        createThread()
                    } else {
                        // Join the thread
                        await connection.invoke("JoinThread", threadId);
                        setThreadId(threadId)
                        // Retrieve existing thread
                        const messages = await connection.invoke("GetThreadMessages", threadId);
                        setMessages(messages)
                    }
                } catch (error) {
                    onError(error)
                }
            })()

            connection.on("MessageCreated", (message) => {
                setMessages(prev => [...prev, message])
            })
            connection.on("MessageUpdated", (message) => {
                console.log(message)
                setMessages(prev => {
                    const existing = prev.find(x => x.id === message.messageId)
                    if (message.text) {
                        if (!existing.content[message.messageIndex]) {
                            existing.content[message.messageIndex] = { text: "" }
                        }
                        existing.content[message.messageIndex].text += message.text
                    }
                    return prev.map(x => x.id === existing.id ? existing : x)
                })
            })
            connection.on("MessageCompleted", (message) => {
                console.log(message)
                setMessages(prev => prev.map(x => x.id === message.id ? message : x))
            })

            connection.on("RunFailed", (run) => {
                console.log(run)
                setMessages(prev => [...prev, {
                    content: [{ text: run.lastError.message }],
                }])
            })

            if (events) {
                events.forEach(event => {
                    connection.on(event.name, event.handler)
                })
            }

            return () => {
                connection.stop();
            };
        }
    }, [connection]);

    const createThread = async () => {
        const threadId = await connection.invoke("CreateThread")
        localStorage.setItem("OptimonThreadId", threadId)
        setThreadId(threadId)
        setMessages([])
        if (startup) {
            await connection.invoke(startup, threadId)
        }
    }
    const reloadThread = async () => {
        const messages = await connection.invoke("GetThreadMessages", threadId);
        setMessages(messages)
    }

    const [boop] = useSound(Sounds.boop);
    var SpeechRecognition = SpeechRecognition || window.webkitSpeechRecognition
    const recognition = new SpeechRecognition();

    recognition.onspeechend = function () {
        recognition.stop();
        setListening(false)
    }

    recognition.onnomatch = event => {
        console.log(event)
        setListening(false)
    }

    recognition.onerror = event => {
        console.log(event)
        setListening(false)
    }

    useEffect(() => {
        scrollTo.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages])

    const addMessage = async message => {
        try {
            setAnswering(true)
            const hotel = {
                id: currentHotel?.Id,
                name: currentHotel?.Name,
                currentBusinessDate: moment(currentHotel?.HotelParameter?.CurrentBusinessDate).startOf("day").toISOString()
            }
            connection.invoke("SendMessage", threadId, message, hotel, instructions)
        } catch (error) {
            onError(error)
        }
        finally {
            setAnswering(false)
        }
    }

    recognition.onresult = event => {
        const transcript = event.results[0][0].transcript;
        addMessage(transcript)
        setListening(false)
    }

    const startMic = () => {
        boop();
        setListening(true)
        recognition.start();
    }

    const onKeyDown = e => {
        switch (e.key) {
            case "Enter":
                {
                    addMessage(message)
                    setMessage("")
                }
                break;
            case "ArrowUp":
                {
                    const list = messages.filter(x => x.role === "User");
                    if (list && list.length) {
                        const message = list[list.length - 1]
                        if (message && message.content) {
                            setMessage(message.content[0].text?.value)
                        }
                    }
                }
                break;
        }
    }

    useEffect(() => {
        const observer = new MutationObserver((mutationsList) => {
          mutationsList.forEach((mutation) => {
            if (mutation.type === "attributes" && mutation.attributeName === "dir") {
              const newDir = mutation.target.getAttribute("dir");
              setDirection(newDir);
            }
          });
        });
    
        if (inputRef.current) {
          observer.observe(inputRef.current.inputRef.current, { attributes: true });
        }
    
        return () => {
          observer.disconnect();
        };
      }, []);

    const icons = ["icon-user", "smile outline"]
    const roles = ["User", "Optimon"]

    return <div className="optimon">
        <List className={direction} items={
            messages.map(message => 
            <List.Item key={message.id} className={roles[message.role]}>
                <List.Icon className={icons[message.role]} />
                <List.Content>
                    <List.Header as='a'>{roles[message.role]}</List.Header>
                    {
                        message.content.map(content => {
                            if (content.text) {
                                let text = content.text
                                if (content.textAnnotations) {
                                    content.textAnnotations.forEach(annotation => {
                                        if (annotation.outputFileId) {
                                            const filetype =annotation.textToReplace.endsWith(".png") ? "image-png" : "application/octet-stream";
                                            const downloadLink = `${endpointAPI}Optimon/GetFile/${annotation.outputFileId}/${filetype}`;
                                            text = text.replace(annotation.textToReplace, downloadLink);
                                        }
                                    });
                                }
                                return <List.Description>
                                    <ReactMarkdown>{text}</ReactMarkdown>
                                </List.Description>
                            }
                            if (content.imageFileId) {
                                return <List.Description>
                                    <Image size="large" src={`${endpointAPI}Optimon/GetFile/${content.imageFileId}/image-png`} />
                                </List.Description>
                            }
                        })
                    }
                </List.Content>
            </List.Item>)
                .concat(<Loader key="loader" active={answering} inline='centered' />)
                .concat(<div key="scrollto" className="scroll-to" ref={scrollTo} />)
        }></List>
        <Input ref={inputRef} fluid icon={{ name: 'microphone', circular: true, link: true, onClick: () => startMic(), disabled: listening }} disabled={!threadId}
           iconPosition={direction === "rtl"?"left":""} placeholder='Type...' onKeyDown={onKeyDown} value={message} onChange={(e, data) => setMessage(data.value)}></Input>

    </div>
}

Optimon.propTypes = {
    onChange: PropTypes.func,
    setFunctions: PropTypes.func,
    fresh: PropTypes.bool,
    instructions: PropTypes.string,
    startup: PropTypes.string,
    events: PropTypes.array
};